import React, { useState } from "react";
import { Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Field, Panel, DelBtn } from "@/pages/admin/adminShared";

export default function BlindStructuresAdmin({ items = [], onCreate, onUpdate, onDelete }) {
  const empty = { name: "", description: "", levels: "" };
  const [f, setF] = useState(empty);
  const [editingId, setEditingId] = useState(null);
  const startEdit = (b) => { setEditingId(b.id); setF({ ...empty, ...b }); window.scrollTo({ top: 0, behavior: "smooth" }); };
  const cancel = () => { setEditingId(null); setF(empty); };
  const submit = async (e) => {
    e.preventDefault();
    const ok = editingId ? await onUpdate(editingId, f) : await onCreate(f);
    if (ok) cancel();
  };
  return (
    <Panel title={editingId ? "Edit Blind Structure" : "New Blind Structure"} form={
      <form onSubmit={submit} className="space-y-3" data-testid="blind-structure-form">
        <Field label="Name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="e.g. Standard 20-min levels" />
        <Field label="Short Description" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} placeholder="e.g. Weekly tournament structure" />
        <div>
          <Label className="text-slate-300 text-xs">Levels (one per line)</Label>
          <Textarea value={f.levels} onChange={(e) => setF({ ...f, levels: e.target.value })} rows={8} placeholder={"25 / 50\n50 / 100\n100 / 200\n..."} className="mt-1 rounded-none bg-navy border-slate-700 text-sm font-mono" data-testid="blind-structure-levels" />
        </div>
        <div className="flex gap-2">
          <Button type="submit" className="flex-1 bg-gold text-navy hover:bg-gold-light rounded-none font-bold uppercase tracking-widest text-xs" data-testid="blind-structure-submit">{editingId ? "Save Changes" : "Add Structure"}</Button>
          {editingId && <Button type="button" onClick={cancel} variant="outline" className="rounded-none border-slate-600 text-slate-300 text-xs">Cancel</Button>}
        </div>
      </form>
    }>
      <div className="space-y-2">
        {items.map((b) => (
          <div key={b.id} className="bg-navy-paper border border-slate-800 p-4 flex items-start justify-between" data-testid={`admin-blind-structure-${b.id}`}>
            <div className="min-w-0">
              <div className="text-white font-medium text-sm">{b.name}</div>
              {b.description && <div className="text-slate-500 text-xs">{b.description}</div>}
              {b.levels && <div className="text-slate-400 text-xs mt-1 whitespace-pre-line line-clamp-3">{b.levels}</div>}
            </div>
            <div className="flex items-center gap-2 shrink-0 ml-3">
              <button onClick={() => startEdit(b)} className="text-slate-500 hover:text-gold transition-colors" data-testid={`admin-edit-blind-structure-${b.id}`}><Pencil className="w-4 h-4" /></button>
              <DelBtn onClick={() => onDelete(b.id)} />
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-slate-500 text-center py-10">No blind structures yet. Create one to use it when building events.</p>}
      </div>
    </Panel>
  );
}
